import { Popover } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import './index.less'
import { cdnUrl } from '@/utils/cdn';

export default function SafetyWarning() {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation()
  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
  };


  return (<div className="safety-warning-box">
    <Popover
      content={<div className="msg-list">
        <p className="num warning-txt"><strong>{t('lpAddBuy.privateKeyProtection')}</strong></p>
        <p className="num warning-txt"><strong>{t('lpAddBuy.recommendedSmallWallets')}</strong></p>
        <p className="num warning-txt"><strong>{t('lpAddBuy.safeCopyPrivateKey')}</strong></p>
        <p className="num warning-txt"><strong>{t('lpAddBuy.officialNoPrivateKeyRequest')}</strong></p>
      </div>}
      overlayClassName="sl-popover"
      trigger="click"
      open={open}
      placement="bottomLeft"
      onOpenChange={handleOpenChange}
    >
      <button><img src={cdnUrl("/img/slerf/safety.svg")} alt="" /><span>{t("lpAddBuy.securityReminder")}</span></button>
    </Popover>
  </div>)
}